var map = {
	"./ag-sport.png": 44680,
	"./ag_casino.png": 53243,
	"./arrow-right.png": 84635,
	"./btisport.png": 85970,
	"./close-gift.png": 17902,
	"./close.png": 73621,
	"./cmd.png": 41185,
	"./content-giftcode.png": 68216,
	"./dg_casino.png": 41802,
	"./dragoon-slot.png": 87594,
	"./evl_casino.png": 26778,
	"./game-bai-icon.png": 59048,
	"./game-fish-icon.png": 56364,
	"./game-tradition-icon.png": 92368,
	"./giftimg-active.png": 39943,
	"./giftimg.png": 76266,
	"./habanero-slot.png": 62580,
	"./home-icon.png": 50668,
	"./ibc.png": 2677,
	"./icon-ds.png": 82210,
	"./jili-fish.png": 78188,
	"./jili-slot.png": 46402,
	"./ketqua.png": 37242,
	"./live-casino.png": 48187,
	"./logo-AsiaLottolive.png": 21637,
	"./lottery-icon.png": 72414,
	"./pg-slot.png": 58725,
	"./pragmatic-slot.png": 53552,
	"./pragmatic_casino.png": 36967,
	"./promotion.png": 21382,
	"./pt-live.png": 23302,
	"./pt-slot.png": 68688,
	"./sa_casino.png": 36583,
	"./sbobet.png": 40422,
	"./sg_casino.png": 77877,
	"./skywind-slot.png": 75459,
	"./slot-icon.png": 52811,
	"./sport-icon.png": 1529,
	"./titleXs.png": 96864,
	"./trochoi.png": 22189,
	"./v8-poker.png": 43959,
	"./wm_casino.png": 78919,
	"./xacnhan.png": 35198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55242;